import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  TOUR_STATUS_REQUESTED,
  TOUR_STATUS_SCHEDULED,
  TOUR_STATUS_COMPLETED,
  TOUR_STATUS_CANCELLED,
  TOUR_SHOWING_STATUS_PENDING,
  TOUR_SHOWING_STATUS_CONFIRMED,
  TOUR_CANCEL_REASON_SAVED_FOR_LATER,
  TOUR_SHOWING_FAILURE_REASON_OPTION_ITEMS,
} from 'common/tourConstants';

import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_ADMIN_MARK_SHOWING_NOT_AVAILABLE,
  SR_API_ACTION_ADMIN_UPDATE_ITEM,
} from 'api/actionTypes';

import {
  DATA_TABLE_SOURCE_ADMIN_TOURS,
} from 'common/dataTableConstants';

import { Tour } from 'client/actions';

import SrOptionSelectionModal from 'client/components/SrOptionSelectionModal';
import SrAdminTourCardRequested from 'client/components/SrAdminTourCard/SrAdminTourCardRequested';
import SrAdminTourCardScheduled from 'client/components/SrAdminTourCard/SrAdminTourCardScheduled';
import SrAdminTourCardCompleted from 'client/components/SrAdminTourCard/SrAdminTourCardCompleted';
import SrAdminShowingNotes from 'client/components/SrAdminShowingNotes';
import SrAdminMessageTenant from 'client/components/SrAdminMessageTenant';
import SrAdminRenterPrequal from 'client/components/SrAdminRenterPrequal';

import {
  actionDataTableLoadItems,
  actionDataTableRemoveItem,
} from 'client/helpers/dataTables';

import postWithState from 'client/actions/postWithState';

const TOUR_STATUS_TO_TOUR_CARD_COMPONENT_MAPPING = {
  [TOUR_STATUS_REQUESTED]: SrAdminTourCardRequested,
  [TOUR_STATUS_SCHEDULED]: SrAdminTourCardScheduled,
  [TOUR_STATUS_COMPLETED]: SrAdminTourCardCompleted,
  // TODO(@d-oliveros): Custom tour cards for these statuses.
  [TOUR_STATUS_CANCELLED]: SrAdminTourCardRequested,
};

class SrAdminTourCard extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    appUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      markAsFailedListingId: null,
      markAsFailedNote: null,
      messageTenantByListingId: null,
      renterPrequalByUserId: null,
    };
  }

  _reloadDataTableTour = (params) => {
    const { tour, dispatch } = this.props;

    const tourIdToLoad = params && typeof params === 'object' && typeof params.tourIdToLoad === 'number'
      ? params.tourIdToLoad
      : tour.id;

    return dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
      viewId: `tour-id-${tourIdToLoad}`,
      filter: {
        'tours.id': tourIdToLoad,
      },
      count: 1,
    });
  }

  _onSaveForLaterButtonClick = ({ listing }) => {
    const { tour, dispatch } = this.props;

    dispatch(Tour.saveShowingForLater, {
      tourId: tour.id,
      listing: listing,
      tourCancelReason: TOUR_CANCEL_REASON_SAVED_FOR_LATER,
      onSuccess: () => {
        return tour.listings.length > 1
          ? this._reloadDataTableTour()
          : (
            dispatch(actionDataTableRemoveItem, {
              dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
              entityId: tour.id,
            })
          );
      },
      userId: tour.user.id,
    });
  }

  _onNotAvailableShowingButtonClick = ({ listingId }) => {
    const markAsFailedNote = global.prompt('Not available reason:') || '';

    this.setState({
      markAsFailedListingId: listingId,
      markAsFailedNote: markAsFailedNote,
    });
  }

  _onMakeAvailableShowingButtonClick = ({ listingId }) => {
    const { tour, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'tourListings',
        where: {
          tourId: tour.id,
          listingId: listingId,
        },
        updates: {
          status: tour.status === TOUR_STATUS_SCHEDULED
            ? TOUR_SHOWING_STATUS_CONFIRMED
            : TOUR_SHOWING_STATUS_PENDING,
          failureReason: null,
          note: null,
        },
      },
    }).then(this._reloadDataTableTour);
  }

  _onNotAvailableShowingModalSubmit = (showingFailureReason) => {
    const { tour, dispatch } = this.props;

    typeCheck('showingFailureReason::NonEmptyString', showingFailureReason);

    const {
      markAsFailedListingId,
      markAsFailedNote,
    } = this.state;

    this.setState({
      markAsFailedListingId: null,
      markAsFailedNote: null,
    });

    if (!global.confirm(`Are you sure you want to update the failure reason to "${showingFailureReason}"?`)) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_MARK_SHOWING_NOT_AVAILABLE,
      payload: {
        tourId: tour.id,
        listingId: markAsFailedListingId,
        note: markAsFailedNote,
        failureReason: showingFailureReason,
      },
    }).then(this._reloadDataTableTour);
  }

  _onNotAvailableShowingModalCancel = () => {
    this.setState({
      markAsFailedListingId: null,
      markAsFailedNote: null,
    });
  }

  _onShowingMarkReadButtonClick = ({ listingId }) => {
    const { tour, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'tourListings',
        where: {
          tourId: tour.id,
          listingId: listingId,
        },
        updates: {
          status: tour.status === TOUR_STATUS_SCHEDULED
            ? TOUR_SHOWING_STATUS_CONFIRMED
            : TOUR_SHOWING_STATUS_PENDING,
        },
      },
    }).then(this._reloadDataTableTour);
  }

  _onOpenShowingNotes = (listingId) => {
    this.setState({
      showingListingId: listingId,
    });
  }

  _onCloseShowingNotes = () => {
    this.setState({
      showingListingId: null,
    });
  }

  _onOpenMessageTenant = (listingId) => {
    this.setState({
      messageTenantByListingId: listingId,
    });
  }

  _onCloseMessageTenant = () => {
    this.setState({
      messageTenantByListingId: null,
    });
  }

  _onOpenRenterPrequal = (userId) => {
    this.setState({
      renterPrequalByUserId: userId,
    });
  }

  _onCloseRenterPrequal = () => {
    this.setState({
      renterPrequalByUserId: null,
    });
  }

  render() {
    const { tour, dispatch } = this.props;
    const {
      markAsFailedListingId,
      showingListingId,
      messageTenantByListingId,
      renterPrequalByUserId,
    } = this.state;
    const markAsFailedListing = tour.listings.find(({ id }) => id === markAsFailedListingId);

    const SrAdminTourCardByStatus = TOUR_STATUS_TO_TOUR_CARD_COMPONENT_MAPPING[tour.status];

    return (
      <div>
        <SrAdminTourCardByStatus
          reloadDataTableTour={this._reloadDataTableTour}
          onSaveForLaterButtonClick={this._onSaveForLaterButtonClick}
          onMakeAvailableShowingButtonClick={this._onMakeAvailableShowingButtonClick}
          onNotAvailableShowingButtonClick={this._onNotAvailableShowingButtonClick}
          onShowingMarkReadButtonClick={this._onShowingMarkReadButtonClick}
          onOpenShowingNotes={this._onOpenShowingNotes}
          onOpenMessageTenant={this._onOpenMessageTenant}
          onOpenRenterPrequal={this._onOpenRenterPrequal}
          {...this.props}
        />
        {markAsFailedListing && (
          <SrOptionSelectionModal
            headline={markAsFailedListing.addressStreetDisplay}
            optionItems={TOUR_SHOWING_FAILURE_REASON_OPTION_ITEMS}
            onSubmit={this._onNotAvailableShowingModalSubmit}
            onCancel={this._onNotAvailableShowingModalCancel}
          />
        )}
        {showingListingId && (
          <SrAdminShowingNotes
            listingId={showingListingId}
            tour={tour}
            onClose={this._onCloseShowingNotes}
            reloadDataTableTour={this._reloadDataTableTour}
            dispatch={dispatch}
          />
        )}
        {messageTenantByListingId && (
          <SrAdminMessageTenant
            listingId={messageTenantByListingId}
            tour={tour}
            onClose={this._onCloseMessageTenant}
            reloadDataTableTour={this._reloadDataTableTour}
            dispatch={dispatch}
          />
        )}
        {renterPrequalByUserId && (
          <SrAdminRenterPrequal
            tour={tour}
            onClose={this._onCloseRenterPrequal}
            reloadDataTableTour={this._reloadDataTableTour}
          />
        )}
      </div>
    );
  }
}

SrAdminTourCard.displayName = 'SrAdminTourCard';

export default SrAdminTourCard;
